import React from 'react';
import PropTypes from 'prop-types';
import './Textarea.scss';

export default function Textarea({ placeholder, ...props }) {
  return (
    <div className="form-custom-input">
      <textarea
        placeholder={placeholder}
        aria-label={placeholder}
        {...props}
        style={{ height: 130 }}
      />
    </div>
  );
}

Textarea.propTypes = {
  placeholder: PropTypes.string,
};

Textarea.defaultProps = {
  placeholder: undefined,
};
